import React from 'react';
import { Tag, Button, Space } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { ShippingChannel } from '../../types/shipping-types';

const SHIPPING_METHOD_MAP = {
    sea: { label: '海运', color: 'blue' },
    air: { label: '空运', color: 'green' },
    express: { label: '快递', color: 'orange' },
    rail: { label: '铁路', color: 'purple' },
    truck: { label: '卡车', color: 'cyan' },
};

export const getChannelColumns = (
    onEdit: (id: number) => void,
    onDelete: (id: number) => void
): ColumnsType<ShippingChannel> => [
        {
            title: '渠道名称',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            fixed: 'left',
        },
        {
            title: '起运地',
            dataIndex: 'origin_location',
            key: 'origin_location',
            width: 150,
        },
        {
            title: '目的地',
            dataIndex: 'destination_country',
            key: 'destination_country',
            width: 120,
        },
        {
            title: '运输方式',
            dataIndex: 'shipping_method',
            key: 'shipping_method',
            width: 100,
            render: (method: keyof typeof SHIPPING_METHOD_MAP) => (
                <Tag color={SHIPPING_METHOD_MAP[method]?.color}>
                    {SHIPPING_METHOD_MAP[method]?.label || method}
                </Tag>
            ),
        },
        {
            title: '时效',
            dataIndex: 'transit_days',
            key: 'transit_days',
            width: 100,
            render: (days: number) => `${days}天`,
        },
        {
            title: '运费阶梯',
            key: 'rate_tiers_count',
            width: 100,
            render: (_, record) => `${record.rate_tiers?.length || 0}个`,
        },
        {
            title: '状态',
            dataIndex: 'is_active',
            key: 'is_active',
            width: 80,
            render: (active: boolean) => (
                <Tag color={active ? 'success' : 'default'}>{active ? '启用' : '停用'}</Tag>
            ),
        },
        {
            title: '创建时间',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 160,
            render: (text: string) => new Date(text).toLocaleString('zh-CN'),
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 200,
            render: (_, record) => (
                <Space size="small">
                    <Button type="link" size="small" icon={<EditOutlined />} onClick={() => onEdit(record.id)}>
                        编辑
                    </Button>
                    <Button
                        type="link"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => onDelete(record.id)}
                    >
                        删除
                    </Button>
                </Space>
            ),
        },
    ];
